/* vl-lazy — below-the-fold pictures wait for the hero (2026-09-23).
   Chrome's loading="lazy" fetches every picture within 1250 px of the fold during the very first layout — on the
   home page that is the category tiles, the promo card and the first product cards, ~350 KB started before the hero
   has painted and sharing its bandwidth. Here such a picture carries data-vl-lazy with data-src / data-srcset
   (a transparent 1×1 GIF in src, the box keeps its size from width/height or CSS), and the real URLs are set:
     • once the page's largest paint is an IMAGE (PerformanceObserver "largest-contentful-paint" with a url —
       the hero, a gallery, a banner), or at `load`, or 2.5 s after this script runs, whichever comes first —
       browsers without that observer (Safari) start at once, exactly like before;
     • from then on when the picture comes within 1000 px of the viewport (IntersectionObserver), which is
       Chrome's own distance for a 4G phone, so scrolling shows nothing different.
   <noscript> copies keep the plain <img> for crawlers and visitors without JavaScript.
   Re-scans on shopify:section:load (theme editor). Exposes window.vlLazy.scan(root) for markup added later. */
(function () {
  var MARGIN = '1000px 0px';
  function hydrate(img) {
    var pic = img.parentElement;
    if (pic && pic.tagName === 'PICTURE') {
      pic.querySelectorAll('source[data-srcset]').forEach(function (s) { s.setAttribute('srcset', s.getAttribute('data-srcset')); s.removeAttribute('data-srcset'); });
    }
    var ss = img.getAttribute('data-srcset'); if (ss) { img.setAttribute('srcset', ss); img.removeAttribute('data-srcset'); }
    var src = img.getAttribute('data-src'); if (src) { img.setAttribute('src', src); img.removeAttribute('data-src'); }
    img.removeAttribute('data-vl-lazy');
  }
  var io = null;
  try {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting || e.intersectionRatio > 0) { io.unobserve(e.target); hydrate(e.target); } });
    }, { rootMargin: MARGIN });
  } catch (e) { io = null; }
  function scan(root) {
    var list = (root && root.querySelectorAll ? root : document).querySelectorAll('img[data-vl-lazy]');
    list.forEach(function (img) { if (io) io.observe(img); else hydrate(img); });
  }
  var started = false;
  function start() { if (started) return; started = true; scan(); }
  var canWait = false;
  try { canWait = document.readyState !== 'complete' && 'PerformanceObserver' in window && (PerformanceObserver.supportedEntryTypes || []).indexOf('largest-contentful-paint') >= 0; } catch (e) {}
  if (canWait) {
    try {
      var po = new PerformanceObserver(function (list) {
        var hit = list.getEntries().some(function (en) { return !!en.url; });
        if (hit) { po.disconnect(); setTimeout(start, 0); }
      });
      po.observe({ type: 'largest-contentful-paint', buffered: true });
    } catch (e) { start(); }
    window.addEventListener('load', start, { once: true });
    setTimeout(start, 2500);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (e) { if (started) scan(e.target); });
  window.vlLazy = { scan: function (root) { if (started) scan(root); }, hydrate: hydrate };
})();
